import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/systems'
import { ADD_ALERT_RECIPIENT_REQUEST } from 'common/actions/user'
import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  isAddingEmail: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.UPDATE_ALARM_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.UPDATE_ALARM_REQUEST.SUCCESS]: () => initialState,
  [constants.UPDATE_ALARM_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  },

  // Track the add-recipient request so the "+" button can show a spinner and
  // stay disabled while the request is in flight.
  [ADD_ALERT_RECIPIENT_REQUEST.START]: state => state.set('isAddingEmail', true),
  [ADD_ALERT_RECIPIENT_REQUEST.SUCCESS]: state => state.set('isAddingEmail', false),
  [ADD_ALERT_RECIPIENT_REQUEST.FAILURE]: state => state.set('isAddingEmail', false)
})
